import { apiSlice } from './apiSlice';

export interface POAItem {
  id?: number;
  name: string;
  unit?: string;
  quantity: number;
  group?: string;
}

export interface POA {
  id: number;
  number: string;
  issueDate: string;
  validUntil?: string | null;
  validityDays?: number | null;
  status: 'draft' | 'final';
  organizationId?: number | null;
  organizationName?: string | null;
  supplierId?: number | null;
  supplierName?: string | null;
  supplierInn?: string | null;
  supplierKpp?: string | null;
  supplierAddress?: string | null;
  employeeFullName?: string | null;
  employeePosition?: string | null;
  employeePassportSeries?: string | null;
  employeePassportNumber?: string | null;
  employeeIssuedBy?: string | null;
  employeeIssuedAt?: string | null;
  vehicleBrand?: string | null;
  vehiclePlate?: string | null;
  trailerPlate?: string | null;
  bankName?: string | null;
  bankAccount?: string | null;
  bankCorrAccount?: string | null;
  bankBik?: string | null;
  createdAt: string;
  items?: POAItem[];
}

export const poaApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPOAs: builder.query<POA[], void>({
      query: () => '/poa',
      transformResponse: (r: any) => r.data || r,
      providesTags: [],
    }),
    getPOAById: builder.query<POA, number>({
      query: (id) => `/poa/${id}`,
      transformResponse: (r: any) => r.data || r,
      providesTags: (_r, _e, id) => [{ type: 'POA', id } as any],
    }),
    createPOA: builder.mutation<POA, Partial<POA>>({
      query: (body) => ({ url: '/poa', method: 'POST', body }),
      transformResponse: (r: any) => r.data || r,
      invalidatesTags: [],
    }),
    updatePOA: builder.mutation<POA, { id: number; data: Partial<POA> }>({
      query: ({ id, data }) => ({ url: `/poa/${id}`, method: 'PUT', body: data }),
      transformResponse: (r: any) => r.data || r,
      invalidatesTags: [],
      async onQueryStarted({ id }, { dispatch, queryFulfilled }) {
        try {
          const { data: updated } = await queryFulfilled;
          dispatch(
            poaApi.util.updateQueryData('getPOAById', id, (draft: POA) => {
              Object.assign(draft, updated);
            })
          );
        } catch {
          /* UI handles save errors */
        }
      },
    }),
    deletePOA: builder.mutation<{ success: boolean }, { id: number; confirm?: boolean }>({
      query: ({ id, confirm = true }) => ({ url: `/poa/${id}?confirm=${confirm}`, method: 'DELETE' }),
      transformResponse: (r: any) => r,
      invalidatesTags: [],
    }),
    exportPOA: builder.query<Blob, number>({
      query: (id) => ({ url: `/poa/${id}/export`, responseHandler: (response) => response.blob() }),
      providesTags: [],
    }),
  }),
});

export const {
  useGetPOAsQuery,
  useGetPOAByIdQuery,
  useCreatePOAMutation,
  useUpdatePOAMutation,
  useDeletePOAMutation,
  useLazyExportPOAQuery,
} = poaApi;


